import React from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Es legal?',
    a: 'Sí — la ley FCRA fue creada exactamente para esto.'
  }, {
    q: '¿Necesito abogado?',
    a: 'No — el proceso está diseñado para seguirse sin experiencia legal.'
  }, {
    q: '¿Sirve con ITIN?',
    a: 'Sí — las leyes aplican igual para SSN e ITIN.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'Para siempre — descarga el PDF y es tuyo.'
  }];
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-16">
      <div className="mx-auto max-w-3xl" data-id="element-17">
        <h2 className="mb-12 text-center text-4xl sm:text-5xl font-bebas text-white" data-id="element-18">
          Preguntas <span className="text-gold-400" data-id="element-19">Frecuentes</span>
        </h2>

        <div className="space-y-6" data-id="element-20">
          {faqs.map((faq, index) => <div key={index} className="rounded-xl bg-navy-800 p-6 border border-slate-700/50" data-id="element-21">
              <h3 className="mb-3 text-xl font-bold text-white" data-id="element-22">{faq.q}</h3>
              <p className="text-slate-300" data-id="element-23">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}